'use client';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import HotPopTopicCardSkeleton from '@fe-news/components/molecules/Member/HotPopTopicCardSkeleton';

// types
import { HotPopTopicCardProps } from '@fe-news/constants/my-track/type';

const HotPopTopicCard = dynamic(() => import('./HotPopTopicCard'), {
  ssr: false,
  loading: () => <HotPopTopicCardSkeleton />
});

const HotPopTopicCardLazy = ({ hotRank, id }: HotPopTopicCardProps) => {
  return (
    <Suspense fallback={<HotPopTopicCardSkeleton />}>
      <HotPopTopicCard hotRank={hotRank} id={id} />
    </Suspense>
  );
};

export default HotPopTopicCardLazy;
